"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.keyExtractor = void 0;
/**
 * Smart keyExtractor function that can be used to extract the key from the item.
 *
 * @param item - The item for which the key should be extracted.
 * @param index - The index of the item in the list.
 * @returns The key of the item.
 */
const keyExtractor = (item, index) => {
  if (typeof item === 'object' && item !== null) {
    if ('key' in item && item.key != null) {
      return String(item.key);
    }
    if ('code' in item && item.code != null) {
      return String(item.code);
    }
    if ('productCode' in item && item.productCode != null) {
      return String(item.productCode);
    }
    if ('id' in item && item.id != null) {
      return String(item.id);
    }
  }
  return String(index);
};
exports.keyExtractor = keyExtractor;
